import { FC } from 'react';
import { Text } from '@chakra-ui/react';

import { WorkflowStepFormFieldWysiwyg } from '../types/workflowStepComponentTypes';
import { FieldToBlock, FieldValueProps } from './declarations';
import { commonFieldBlockProps } from './FieldUtils';

export const WysiwygFieldToBlock: FieldToBlock<
  'wysiwyg',
  WorkflowStepFormFieldWysiwyg
> = (field) => ({
  ...commonFieldBlockProps(field),
  componentType: 'wysiwyg',
  componentProps: {
    disabled: field.disabled ?? false,
    size: 'sm',
  },
});

type TextFieldValueProps = FieldValueProps<'wysiwyg'>;

export const WysiwygFieldValue: FC<TextFieldValueProps> = ({ field }) => (
  <Text>{field.value}</Text>
);
